<template>
  <div>
    <!-- 添加菜品 -->
    <el-dialog :close-on-click-modal="false"
      :title="titleType"
      :visible.sync="vegetableVisible"
      :before-close="vegetableHandleClose"
      width="43%"
      center
    >
      <el-divider></el-divider>
      <div class="vegetableForm">
        <el-form ref="form" :model="form" label-width="80px">
          <div class="itemOne">
            <el-form-item label="名称:">
              <span class="xingA">*</span>
              <el-input v-model="form.name" placeholder="名称"></el-input>
            </el-form-item>
            <el-form-item label="价格:">
              <span class="xingA">*</span>
              <el-input v-model="form.name" placeholder="价格"></el-input>
            </el-form-item>
            <span class="dw">元</span>
          </div>
          <div class="itemTwo">
            <el-form-item label="分类:">
              <span class="xingA">*</span>
              <el-select v-model="value" placeholder="菜品分类">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="单位:">
              <span class="xingA">*</span>
              <el-input v-model="form.name" placeholder="单位"></el-input>
            </el-form-item>
            <el-form-item label="状态:">
              <span class="xingA">*</span>
              <el-select v-model="value" placeholder="上下架状态">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="简介:">
              <el-input
                type="textarea"
                :autosize="{minRows:3,maxRows:5}"
                v-model="form.name"
                placeholder="--"
              ></el-input>
            </el-form-item>
          </div>
          <div class="itemThree">
            <el-form-item label="每日库存:">
              <el-input v-model="form.name" placeholder="--"></el-input>
              <span>
                <span>注:</span>
                <span>0代表不限制库存</span>
              </span>
            </el-form-item>
          </div>
          <div class="itemThree">
            <el-form-item label="单次限制:">
              <el-input v-model="form.name" placeholder="--"></el-input>
              <span>
                <span>注:</span>
                <span>用户每次下单的限制数量,0代表不限制购买</span>
              </span>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="销售日期:">
              <el-date-picker
                v-model="value1"
                type="daterange"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="时间设置:">
              <el-time-picker
                is-range
                v-model="value1"
                range-separator="至"
                start-placeholder="开始时间"
                end-placeholder="结束时间"
                placeholder="选择时间范围"
              ></el-time-picker>
            </el-form-item>
          </div>
          <div class="itemFour">
            <el-form-item label="档口:">
              <span class="xingA">*</span>
              <el-select v-model="value" placeholder="上下架状态">
                <el-option
                  v-for="item in options"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                ></el-option>
              </el-select>
            </el-form-item>
          </div>
          <div>
            <el-form-item label="上传图片:">
              <span class="xingB">*</span>
              <el-upload action="#" list-type="picture-card" :auto-upload="false">
                <i slot="default" class="el-icon-plus"></i>
                <div slot="file" slot-scope="{file}">
                  <img class="el-upload-list__item-thumbnail" :src="file.url" alt />
                  <span class="el-upload-list__item-actions">
                    <span
                      class="el-upload-list__item-preview"
                      @click="handlePictureCardPreview(file)"
                    >
                      <i class="el-icon-zoom-in"></i>
                    </span>
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleDownload(file)"
                    >
                      <i class="el-icon-download"></i>
                    </span>
                    <span
                      v-if="!disabled"
                      class="el-upload-list__item-delete"
                      @click="handleRemove(file)"
                    >
                      <i class="el-icon-delete"></i>
                    </span>
                  </span>
                </div>
              </el-upload>
              <el-dialog :close-on-click-modal="false" :visible.sync="dialogVisible">
                <img width="100%" :src="dialogImageUrl" alt />
              </el-dialog>
            </el-form-item>
            <el-form-item class="itemBtn">
              <el-button>重置</el-button>
              <el-button class="btnL">确认保存</el-button>
            </el-form-item>
          </div>
        </el-form>
      </div>
    </el-dialog>
    <!-- 添加菜品 -->
    <!-- 添加桌位 -->
    <el-dialog :close-on-click-modal="false"
      :title="titleTable"
      :visible.sync="tableVisible"
      :before-close="tableHandleClose"
      width="25.6%"
      center
      top="30vh"
    >
      <el-divider></el-divider>
      <div class="vegetableForm">
        <el-form ref="form" :model="form" label-width="80px">
          <el-form-item label="餐桌编号:">
            <span class="xingB">*</span>
            <el-input placeholder="请输入"></el-input>
          </el-form-item>
          <el-form-item class="itemBtn">
            <el-button>重置</el-button>
            <el-button class="btnL">确认保存</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-dialog>
    <!-- 添加桌位 -->
    <!-- 查看二维码 -->
    <el-dialog :close-on-click-modal="false"
      title="餐桌二维码"
      :visible.sync="codeVisible"
      :before-close="codeHandleClose"
      width="22.8%"
      center
      top="30vh"
    >
      <el-divider></el-divider>
      <!-- <div class="codeBox"> -->
      <!-- <div class="qrcode" ref="qrCodeUrl"></div> -->
      <!-- </div> -->
    </el-dialog>
    <!-- 查看二维码 -->
    <!-- 订单详情 -->
    <div class="dialogOrder">
      <el-dialog :close-on-click-modal="false"
        title="订单详情"
        :visible.sync="orderInfoVisible"
        :before-close="orderInfoHandleClose"
        width="25%"
        center
        top="15vh"
      >
        <el-divider></el-divider>
        <div class="orderList">
          <div class="orderOne">中餐馆</div>
          <div class="orderTwo">
            <img src="@/images/scenic/xian.png" alt />
          </div>
          <div class="orderFive">
            <div>
              <span>桌号:</span>
              <span>146545641</span>
            </div>
            <div>
              <span>点单号:</span>
              <span>23156468521332</span>
            </div>
            <div>
              <span>下单时间:</span>
              <span>23156468521332</span>
            </div>
          </div>
          <div class="orderThree">
            <img src="@/images/scenic/xian3.png" alt />
          </div>
          <div class="orderFour">
            <div>菜品名称</div>
            <div>
              <div>单价</div>
              <div>数量</div>
              <div>金额</div>
            </div>
          </div>
          <div class="orderThree">
            <img src="@/images/scenic/xian3.png" alt />
          </div>
          <div class="orderSex">
            <div>
              <div>黄花菜案件嘎空间规划都看过了</div>
              <div>
                <div>23.00</div>
                <div>23</div>
                <div>39.00</div>
              </div>
            </div>
            <div>
              <div>黄花菜案件嘎空间规划都看过了</div>
              <div>
                <div>23.00</div>
                <div>23</div>
                <div>39.00</div>
              </div>
            </div>
          </div>
          <div class="orderThree">
            <img src="@/images/scenic/xian3.png" alt />
          </div>
          <div class="orderSeven">
            <div>
              <span>合计:</span>
              <span>39.00</span>
            </div>
            <div>
              <span>备注:</span>
              <span>
                <el-input type="textarea"></el-input>
              </span>
            </div>
          </div>
          <div class="order11">
            <el-button>打印出票</el-button>
            <el-button>机器补打</el-button>
          </div>
        </div>
      </el-dialog>
    </div>
    <!-- 订单详情 -->
  </div>
</template>

<script>
// import QRCode from "qrcodejs2";
export default {
  data() {
    return {
      value1: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
      vegetableVisible: false, //添加菜品
      tableVisible: false, //添加桌位
      codeVisible: false, //查看二维码
      orderInfoVisible: false, //订单详情
      titleType: "", // 标题区别
      titleTable: "", // 标题区别
      form: {
        name: ""
      },
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: "",
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      value1: "",
      // 图片上传
      dialogImageUrl: "",
      dialogVisible: false,
      disabled: false
    };
  },
  mounted() {
    this.creatQrCode();
  },
  methods: {
    // 订单详情
    orderInfo(row) {
      this.orderInfoVisible = true;
    },
    // 订单详情X
    orderInfoHandleClose() {
      this.orderInfoVisible = false;
    },
    // 餐桌二维码
    creatQrCode() {
      //   var qrcode = new QRCode(this.$refs.qrCodeUrl, {
      //     text: "https://blog.csdn.net/weixin_42601136", // 需要转换为二维码的内容
      //     width: 357,
      //     height: 357,
      //     colorDark: "#000000",
      //     colorLight: "#ffffff",
      //     correctLevel: QRCode.CorrectLevel.H
      //   });
    },
    // 查看二维码
    codeSee(row) {
      this.codeVisible = true;
      this.creatQrCode();
    },
    // 查看二维码X
    codeHandleClose() {
      this.codeVisible = false;
    },
    // 添加桌位
    addTable(row) {
      this.tableVisible = true;
      if (row) {
        this.titleTable = "编辑桌位";
      } else {
        this.titleTable = "添加桌位";
      }
    },
    tableHandleClose() {
      this.tableVisible = false;
    },
    // 添加菜品
    vegetable(row) {
      this.vegetableVisible = true;
      if (row) {
        this.titleType = "编辑菜品";
      } else {
        this.titleType = "添加菜品";
      }
    },
    vegetableHandleClose() {
      this.vegetableVisible = false;
    },
    // 图片上传
    handleRemove(file) {
      console.log(file);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    handleDownload(file) {
      console.log(file);
    }
  }
};
</script>

<style lang='less' scoped>
.orderList {
  width: 360px;
  // height: 365px;
  margin: auto;
  .order11 {
    width: 100%;
    margin-top: 40px;
    margin-bottom: 10px;
    display: flex;
    justify-content: center;
    .el-button {
      width: 110px;
      background: #ffffff;
      border: 1px solid #246deb;
      border-radius: 4px;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #246deb;
      margin: 0 10px;
    }
  }
  .orderSeven {
    /deep/.el-textarea__inner {
    display: block;
    resize: vertical;
    padding: 5px 15px;
    line-height: 1.5;
    box-sizing: border-box;
    width: 100%;
    font-size: inherit;
    color: #000000;
    background-color: #FFF;
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
}
    > div {
      margin: 10px 0;
      display: flex;
      > span:nth-child(1) {
        width: 60px;
        text-align: right;
        display: inline-block;
        margin-right: 10px;
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }
      > span:nth-child(2) {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #000000;
        .el-textarea {
          width: 280px;
        }
      }
    }
  }
  .orderSex {
    margin: 10px 0;
    > div {
      display: flex;
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #000000;
      margin: 5px 0;
      > div:nth-child(1) {
        width: 50%;
        display: flex;
        margin-right: 20px;
      }
      > div:nth-child(2) {
        width: 40%;
        display: flex;
        justify-content: space-between;
      }
    }
  }
  .orderFour {
    display: flex;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #666666;

    > div:nth-child(1) {
      width: 50%;
      margin-right: 20px;
    }
    > div:nth-child(2) {
      width: 40%;
      display: flex;
      justify-content: space-between;
    }
  }
  .orderFive {
    > div {
      margin: 7px 0;
      > span:nth-child(1) {
        width: 60px;
        display: inline-block;
        text-align: right;
        margin-right: 10px;
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #666666;
      }
      > span:nth-child(2) {
        font-family: "OPPOSans";
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: #000000;
      }
    }
  }
  .orderOne {
    margin-top: 40px;
    margin-bottom: 15px;
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 18px;
    color: #000000;
    text-align: center;
  }
}
.vegetableForm {
  /deep/.el-form-item__label {
    font-family: "OPPOSans";
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    color: #666666;
  }
  .el-form-item {
    position: relative;
  }
  .xingA {
    position: absolute;
    top: 0px;
    left: -50px;
    color: #e74c3c;
  }
  .xingB {
    position: absolute;
    top: 0px;
    left: -78px;
    color: #e74c3c;
  }
  .itemBtn {
    display: flex;
    justify-content: center;
    margin-top: 40px;
    margin-bottom: 20px;
    margin-left: -80px;
    /deep/.el-button {
      width: 100px;
      height: 40px;
      background: #d9d9d9;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
      border: none;
    }
    .btnL {
      width: 100px;
      height: 40px;
      background: #246deb;
      border-radius: 4px;
      font-family: ".PingFang SC";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      text-align: center;
      color: #ffffff;
    }
  }
  .itemFour {
    .el-select {
      width: 350px;
    }
  }
  .itemThree {
    display: flex;
    .el-input {
      width: 120px;
    }
    span {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      color: #e74c3c;
      > span:nth-child(1) {
        margin: 0 10px;
      }
    }
  }
  .itemTwo {
    display: flex;
  }
  .itemOne {
    display: flex;
    > div:nth-child(1) {
      .el-input {
        width: 470px;
      }
    }
    > div:nth-child(2) {
      .el-input {
        width: 120px;
      }
    }
    .dw {
      font-family: "OPPOSans";
      font-style: normal;
      font-weight: 400;
      font-size: 14px;
      line-height: 40px;
      color: #666666;
      margin-left: 10px;
    }
  }
}
/deep/.el-dialog__header {
  // height: 60px;
  // line-height: 60px;
  // padding: 0;
}

/deep/.el-dialog__body {
  padding: 0px 20px 20px;
}

// 弹框标题设置
/deep/.el-dialog__title {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

/deep/.el-icon-close {
  font-family: ".PingFang SC";
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 28px;
  /* identical to box height */
  color: #000000;
}

// 分割线
/deep/.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
}
</style>